import React from 'react';
import { Circle } from 'react-leaflet';
import { shallowEqual, useSelector } from 'react-redux';

import { AppState } from '../../../store/interfaces';

export const FilterRadius = function ({ lat, lng }) {
  const radius = useSelector((app: AppState) => app.map.radius, shallowEqual);

  if (!radius) {
    return null;
  }

  if (lng === undefined || Number.isNaN(lng) || lat === undefined || Number.isNaN(lat)) {
    return null;
  }

  const metersInMiles = 1609.34;

  return (
    <Circle
      center={{
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      }}
      radius={radius! * metersInMiles}
      weight={2}
      pathOptions={{ color: '#06AF50', fill: false }}
    />
  );
};
